import React, { useState, useEffect, useMemo, useRef } from 'react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { FixedSizeList as List } from 'react-window';
import './TeklifGonder.css';

const TeklifGonder = () => {
  // 🔹 MOD SEÇİMİ
  const [mod, setMod] = useState('firma'); // 'firma' veya 'tedarikci'
  // ✅ Orijinal state'ler
  const [iskonto, setIskonto] = useState(0);
  const [doviz, setDoviz] = useState('₺');
  const [firmalar, setFirmalar] = useState([]);
  const [modellerByFirma, setModellerByFirma] = useState({}); // { "Firma A": ["Model X", "Model Y"], ... }
  const [seciliFirmalar, setSeciliFirmalar] = useState([]); // birden fazla firma
  const [seciliModeller, setSeciliModeller] = useState({}); // { "Firma A": "Model X", ... }
  // 🔹 MÜŞTERİ BİLGİLERİ (HER İKİ MOD İÇİN)
  const [musteriBilgileri, setMusteriBilgileri] = useState({
    firma: '',
    tlpNo: '',
    ilgili: '',
    email: '',
    gsm: ''
  });
  // 👤 MÜŞTERİ YÖNETİMİ İÇİN YENİ STATE'LER
  const [musteriler, setMusteriler] = useState([]);
  const [seciliMusteriId, setSeciliMusteriId] = useState(null);
  const [musteriModalAcik, setMusteriModalAcik] = useState(false);
  const [yeniMusteriForm, setYeniMusteriForm] = useState({
    firma: '',
    ilgili: '',
    email: '',
    gsm: ''
  });
  // 🔹 YENİ: TEKLİF NO → OTOMATİK Tarih Formatında (YYYYMMDD)
  const bugununTarihi = () => {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, '0');
    const d = String(now.getDate()).padStart(2, '0');
    return `${y}${m}${d}`;
  };
  const [teklifNo, setTeklifNo] = useState(bugununTarihi());
  // 🔹 YENİ: TEKLİF PARA BİRİMİ SEÇİMİ
  const [teklifParaBirimi, setTeklifParaBirimi] = useState('₺');
  // 🔹 YENİ: FİYAT DETAYINI GÖSTER/GİZLE
  const [fiyatDetayGoster, setFiyatDetayGoster] = useState(true);
  // 🔹 YENİ: BİRİM FİYATI GÖSTER/GİZLE
  const [birimFiyatGoster, setBirimFiyatGoster] = useState(true);
  // 🔹 YENİ: ÇOKLU FOTOĞRAF YÜKLEME
  const [fotoDosyalar, setFotoDosyalar] = useState([]);
  const [fotoUrlList, setFotoUrlList] = useState([]);
  // 🔹 YENİ: EK SAYFA İÇİN SERBEST METİN
  const [ekAciklamalar, setEkAciklamalar] = useState('');
  // 🔹 YENİ: MAİL AÇIKLAMASI İÇİN
  const [mailAciklamasi, setMailAciklamasi] = useState('');
  // Yeni alanlar (HER İKİ MODDA DA)
  const [iscilikSaat, setIsclikSaat] = useState(0);
  const [iscilikUcreti, setIsclikUcreti] = useState(0);
  const [yolMesafe, setYolMesafe] = useState(0);
  const [yakitFiyat, setYakitFiyat] = useState(35);
  const [aracTuketimi, setAracTuketimi] = useState(10);
  // 🔹 TEDARİKÇİ MODU İÇİN
  const [tedarikciler, setTedarikciler] = useState([]);
  const [seciliTedarikci, setSeciliTedarikci] = useState('');
  const [aramaKelimesi, setAramaKelimesi] = useState('');
  const [filteredParcalar, setFilteredParcalar] = useState([]);
  const [parcalar, setParcalar] = useState([]);
  const [tumSecilenParcalar, setTumSecilenParcalar] = useState([]);
  const [seciliParcalar, setSeciliParcalar] = useState(new Set());
  const [secilenFiyatlar, setSecilenFiyatlar] = useState({});
  const [parcaAdetleri, setParcaAdetleri] = useState({});
  const [parcaTedarikcisi, setParcaTedarikcisi] = useState({});
  // 🔹 TEK DÖVİZ KURU GİRİŞİ
  const [seciliDoviz, setSeciliDoviz] = useState('EUR');
  const [manuelKur, setManuelKur] = useState(38.0);
  // 🔹 YENİ: BAKIM İŞLERİ VE TİCARİ KOŞULLAR
  const [bakimIsleri, setBakimIsleri] = useState(['HAVA VE YAĞ FİLTRESİ', 'SEPARATÖR KİT', 'YAĞ DEĞİŞİM']);
  const [yeniBakimIsi, setYeniBakimIsi] = useState('');
  const [seciliBakimIndex, setSeciliBakimIndex] = useState(null);
  const [ticariKosullar, setTicariKosullar] = useState({
    teslimSuresi: 'Hemen',
    nakliye: 'Dahil',
    odemeSekli: 'Fatura Tarihinden İtibaren 15 Gün Vade',
    kdv: 'Belirtilen fiyatlara %20 K.D.V. ilave edilecektir.'
  });
  // 🔹 YENİ: PDF ÖN İZLEME
  const [pdfOnizlemeUrl, setPdfOnizlemeUrl] = useState(null);
  // 🔹 YENİ: KAR YÜZDESİ
  const [karYuzdesi, setKarYuzdesi] = useState(0);
  // 🔹 YENİ: KDV OPSİYONEL
  const [kdvDahilMi, setKdvDahilMi] = useState(true);
  // 🔹 EK MALİYETLER PANELİ
  const [ekMaliyetlerAcik, setEkMaliyetlerAcik] = useState(false);
  // 🔹 YENİ: MANUEL PARÇA EKLEME
  const [manuelParcaForm, setManuelParcaForm] = useState({
    kod: '',
    ad: '',
    fiyat: '',
    adet: 1,
    doviz: '€'
  });
  const [manuelParcalar, setManuelParcalar] = useState([]);
  // 🔹 FIRMA MODU İÇİN PARÇA LİSTESİ
  const [parcalarMap, setParcalarMap] = useState({}); // { "Firma|Model": [parca1, parca2, ...] }
  // 🔹 FIRMA DROPDOWN AÇIK/KAPALI
  const [firmaDropdownAcik, setFirmaDropdownAcik] = useState(false);
  const [firmaArama, setFirmaArama] = useState('');
  const dropdownRef = useRef(null);

  // Bellek temizliği
  useEffect(() => {
    return () => {
      if (pdfOnizlemeUrl) URL.revokeObjectURL(pdfOnizlemeUrl);
      fotoUrlList.forEach(url => URL.revokeObjectURL(url));
    };
  }, [pdfOnizlemeUrl, fotoUrlList]);

  // Fotoğraf önizleme
  useEffect(() => {
    const urls = fotoDosyalar.map(file => URL.createObjectURL(file));
    setFotoUrlList(urls);
    return () => urls.forEach(url => URL.revokeObjectURL(url));
  }, [fotoDosyalar]);

  // MOD DEĞİŞİNCE TEMİZLE
  useEffect(() => {
    if (mod === 'firma') {
      setParcalar([]);
      setFilteredParcalar([]);
      setSeciliTedarikci('');
      setAramaKelimesi('');
      setSeciliFirmalar([]);
      setSeciliModeller({});
      setParcalarMap({});
    } else {
      setParcalar([]);
      setFilteredParcalar([]);
      setAramaKelimesi('');
    }
  }, [mod]);

  // 🔹 FIRMA VERİLERİNİ YÜKLE (ALFABETİK)
  useEffect(() => {
    fetch('/api/kayitlar')
      .then(res => res.json())
      .then(data => {
        const firmaListesi = [...new Set(data.map(k => k.firma))].sort((a, b) =>
          a.localeCompare(b, 'tr')
        );
        setFirmalar(firmaListesi);
      })
      .catch(err => console.error("Firma verileri alınamadı:", err));
  }, []);

  // 👤 MÜŞTERİLERİ YÜKLE
  useEffect(() => {
    fetch('/api/musteriler')
      .then(res => res.json())
      .then(data => setMusteriler(data))
      .catch(err => console.error("Müşteri verisi alınamadı:", err));
  }, []);

  // 👤 SEÇİLİ MÜŞTERİ DEĞİŞİNCE BİLGİLERİ GÜNCELLE
  useEffect(() => {
    if (seciliMusteriId !== null) {
      const musteri = musteriler.find(m => m.id === seciliMusteriId);
      if (musteri) {
        setMusteriBilgileri({
          firma: musteri.firma || '',
          tlpNo: musteri.tlpNo || '',
          ilgili: musteri.ilgili || '',
          email: musteri.email || '',
          gsm: musteri.gsm || ''
        });
      }
    }
  }, [seciliMusteriId, musteriler]);

  // 🔹 MODEL VERİLERİNİ FIRMA BAZINDA YÜKLE (ALFABETİK)
  useEffect(() => {
    if (mod !== 'firma' || seciliFirmalar.length === 0) return;
    const loadModels = async () => {
      try {
        const response = await fetch('/api/kayitlar');
        const data = await response.json();
        const yeniModellerByFirma = { ...modellerByFirma };
        for (const firma of seciliFirmalar) {
          if (modellerByFirma[firma]) continue; // Zaten yüklendi
          const filtreli = data.filter(k => k.firma === firma);
          const modellerListesi = [...new Set(filtreli.map(k => k.model))].sort((a, b) =>
            a.localeCompare(b, 'tr')
          );
          yeniModellerByFirma[firma] = modellerListesi;
        }
        setModellerByFirma(yeniModellerByFirma);
      } catch (err) {
        console.error("Model verileri alınamadı:", err);
      }
    };
    loadModels();
  }, [seciliFirmalar, mod]);

  // 🔹 PARÇA VERİLERİNİ FIRMA + MODEL BAZINDA YÜKLE
  useEffect(() => {
    if (mod !== 'firma') return;
    const loadParcalar = async () => {
      try {
        const response = await fetch('/api/kayitlar');
        const data = await response.json();
        const yeniParcalarMap = { ...parcalarMap };
        for (const firma of seciliFirmalar) {
          const model = seciliModeller[firma];
          if (!model) continue;
          const secili = data.find(k => k.firma === firma && k.model === model);
          if (!secili || !secili.parcalar) {
            delete yeniParcalarMap[`${firma}|${model}`];
            continue;
          }
          const parcaListesi = Object.entries(secili.parcalar).map(([ad, tedarikciler]) => {
            const ilk = tedarikciler[0] || {};
            const fiyat = parseFloat(ilk.fiyat) || 0;
            return {
              ad,
              kod: ilk.kod,
              fiyat,
              tedarikci: ilk.adi,
              tedarikciler: tedarikciler.map(t => ({ ...t, fiyat: parseFloat(t.fiyat) || 0 })),
              seciliIndex: 0,
              adet: 1,
              doviz: '€',
              uniqueKey: `${firma}|${model}|${ilk.kod}`
            };
          });
          yeniParcalarMap[`${firma}|${model}`] = parcaListesi;
        }
        setParcalarMap(yeniParcalarMap);
      } catch (err) {
        console.error("Parça verisi alınamadı:", err);
      }
    };
    const hasValidSelection = seciliFirmalar.some(f => seciliModeller[f]);
    if (hasValidSelection) {
      loadParcalar();
    }
  }, [seciliModeller, seciliFirmalar, mod]);

  // 🔹 TEDARİKÇİ VERİLERİ
  useEffect(() => {
    fetch('/api/suppliers')
      .then(res => res.json())
      .then(data => setTedarikciler(data))
      .catch(err => console.error("Tedarikçi verisi alınamadı:", err));
  }, []);

  // 🔹 PARÇA ÇIKARMA (tedarikçi modu için)
  const extractParts = (rows, tedarikciAd) => {
    if (!rows || rows.length === 0) return [];
    return rows.slice(1).map(row => {
      const rowData = Object.values(row);
      if (rowData.length < 3) return null;
      const kod = (rowData[0] || '').toString().trim();
      const ad = (rowData[1] || 'Bilinmeyen').toString().trim();
      const listeFiyat = parseFloat(rowData[2]) || 0;
      const bayiNakit = parseFloat(rowData[3]) || 0;
      const bayi60 = parseFloat(rowData[4]) || 0;
      if (!kod || ad === 'Sil' || ad.length < 2) return null;
      return {
        kod,
        ad,
        listeFiyat,
        bayiNakit,
        bayi60,
        tedarikci: tedarikciAd,
        adet: 1,
        doviz: '€',
        uniqueKey: `tedarikci|${kod}`
      };
    }).filter(Boolean);
  };

  // 🔹 TEDARİKÇİ SEÇİMİ
  useEffect(() => {
    if (mod === 'tedarikci' && seciliTedarikci) {
      const tedarikci = tedarikciler.find(t => t.id === seciliTedarikci);
      if (tedarikci && tedarikci.parcalar) {
        const parcaListesi = extractParts(tedarikci.parcalar, tedarikci.ad);
        setParcalar(parcaListesi);
      } else {
        setParcalar([]);
      }
    } else {
      setParcalar([]);
    }
  }, [mod, seciliTedarikci, tedarikciler]);

  // 🔹 ARAMA FİLTRESİ (tedarikçi modu için)
  useEffect(() => {
    const arama = aramaKelimesi.toLowerCase().trim();
    if (!arama || parcalar.length === 0) {
      setFilteredParcalar([]);
    } else {
      const sonuc = parcalar.filter(p =>
        p.ad.toLowerCase().includes(arama) ||
        p.kod.toLowerCase().includes(arama)
      );
      setFilteredParcalar(sonuc);
    }
  }, [aramaKelimesi, parcalar]);

  // 🔹 PARÇA SEÇİMİ (ORTAK)
  const toggleSecim = (uniqueKey, parca) => {
    setSeciliParcalar(prev => {
      const newSet = new Set(prev);
      if (newSet.has(uniqueKey)) {
        newSet.delete(uniqueKey);
        setTumSecilenParcalar(prevList => prevList.filter(p => p.uniqueKey !== uniqueKey));
      } else {
        newSet.add(uniqueKey);
        setTumSecilenParcalar(prevList => [...prevList, {
          ...parca,
          adet: parcaAdetleri[uniqueKey] || 1,
          fiyatTipi: secilenFiyatlar[uniqueKey] || 'liste'
        }]);
      }
      return newSet;
    });
    if (!parcaTedarikcisi[uniqueKey]) {
      setParcaTedarikcisi(prev => ({ ...prev, [uniqueKey]: parca.tedarikci }));
    }
  };

  const handleParcaDegis = (uniqueKey, field, value) => {
    const yeniAdet = parseFloat(value) || 1;
    setParcaAdetleri(prev => ({ ...prev, [uniqueKey]: yeniAdet }));
    setTumSecilenParcalar(prev =>
      prev.map(p => p.uniqueKey === uniqueKey ? { ...p, adet: yeniAdet } : p)
    );
  };

  const handleFiyatSec = (uniqueKey, tip) => {
    setSecilenFiyatlar(prev => ({ ...prev, [uniqueKey]: tip }));
    setTumSecilenParcalar(prev =>
      prev.map(p => p.uniqueKey === uniqueKey ? { ...p, fiyatTipi: tip } : p)
    );
  };

  // 🔹 SEÇİLEN PARÇAYI KALDIR
  const handleRemove = (uniqueKey) => {
    setTumSecilenParcalar(prev => prev.filter(p => p.uniqueKey !== uniqueKey));
    setSeciliParcalar(prev => {
      const newSet = new Set(prev);
      newSet.delete(uniqueKey);
      return newSet;
    });
  };

  // ✅ Orijinal fonksiyonlar (firma modu - GÜNCELLENDİ)
  const handleTedarikciSec = (uniqueKey, secimIndex, tedarikcilerList) => {
    const secim = tedarikcilerList[secimIndex];
    const fiyat = parseFloat(secim.fiyat) || 0;

    // 1. tumSecilenParcalar'ı güncelle
    setTumSecilenParcalar(prev =>
      prev.map(p =>
        p.uniqueKey === uniqueKey
          ? {
              ...p,
              seciliIndex: secimIndex,
              kod: secim.kod,
              fiyat,
              tedarikci: secim.adi,
              tedarikciler: tedarikcilerList
            }
          : p
      )
    );

    // 2. parcalarMap'i de güncelle → UI doğru seciliIndex'i gösterebilir
    setParcalarMap(prev => {
      const yeniMap = { ...prev };
      for (const key in yeniMap) {
        yeniMap[key] = yeniMap[key].map(p => {
          if (p.uniqueKey === uniqueKey) {
            return {
              ...p,
              seciliIndex: secimIndex,
              kod: secim.kod,
              fiyat,
              tedarikci: secim.adi,
              tedarikciler: tedarikcilerList
            };
          }
          return p;
        });
      }
      return yeniMap;
    });
  };

  // 🔹 MANUEL PARÇA EKLEME FONKSİYONLARI
  const handleManuelParcaDegis = (field, value) => {
    setManuelParcaForm(prev => ({ ...prev, [field]: value }));
  };

  const handleManuelParcaEkle = () => {
    const { kod, ad, fiyat, adet, doviz } = manuelParcaForm;
    if (!kod.trim() || !ad.trim() || !fiyat || adet <= 0) {
      alert("Lütfen tüm alanları doğru doldurun.");
      return;
    }
    const fiyatNum = parseFloat(fiyat);
    const adetNum = parseFloat(adet);
    const uniqueId = `manuel_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    const yeniParca = {
      kod: kod.trim(),
      ad: ad.trim(),
      listeFiyat: fiyatNum,
      bayiNakit: fiyatNum,
      bayi60: fiyatNum,
      tedarikci: "Manuel",
      adet: adetNum,
      doviz,
      fiyatTipi: 'liste',
      manuelId: uniqueId,
      uniqueKey: uniqueId
    };
    setManuelParcalar(prev => [...prev, yeniParca]);
    setTumSecilenParcalar(prev => [...prev, yeniParca]);
    setManuelParcaForm({ kod: '', ad: '', fiyat: '', adet: 1, doviz: '€' });
  };

  const handleManuelParcaSil = (uniqueId) => {
    setManuelParcalar(prev => prev.filter(p => p.manuelId !== uniqueId));
    setTumSecilenParcalar(prev => prev.filter(p => p.uniqueKey !== uniqueId));
  };

  // 👤 MÜŞTERİ MODAL FONKSİYONLARI
  const handleYeniMusteriDegis = (field, value) => {
    setYeniMusteriForm(prev => ({ ...prev, [field]: value }));
  };

  const handleYeniMusteriEkle = async () => {
    const { firma, ilgili, email, gsm } = yeniMusteriForm;
    if (!firma.trim()) {
      alert("Firma adı zorunludur.");
      return;
    }
    try {
      const response = await fetch('/api/musteriler', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ firma, ilgili, email, gsm })
      });
      const yeniMusteri = await response.json();
      setMusteriler(prev => [...prev, yeniMusteri]);
      setSeciliMusteriId(yeniMusteri.id);
      setMusteriModalAcik(false);
      setYeniMusteriForm({ firma: '', ilgili: '', email: '', gsm: '' });
    } catch (err) {
      console.error("Müşteri kaydedilemedi:", err);
      alert("Müşteri kaydedilemedi.");
    }
  };

  const handleMusteriSil = async (id) => {
    if (!window.confirm("Bu müşteriyi silmek istediğinizden emin misiniz?")) return;
    try {
      await fetch(`/api/musteriler/${id}`, { method: 'DELETE' });
      setMusteriler(prev => prev.filter(m => m.id !== id));
      if (seciliMusteriId === id) {
        setSeciliMusteriId(null);
        setMusteriBilgileri({ firma: '', tlpNo: '', ilgili: '', email: '', gsm: '' });
      }
    } catch (err) {
      console.error("Müşteri silinemedi:", err);
      alert("Müşteri silinemedi.");
    }
  };

  const handleMusteriSec = (id) => {
    setSeciliMusteriId(id);
    setMusteriModalAcik(false);
  };

  // ✅ TOPLAM HESAPLAMALAR — GÜNCELLENDİ
  const kdvOrani = 0.2;
  const secilenler = tumSecilenParcalar || [];
  const araToplamIscilik = parseFloat(iscilikSaat) * parseFloat(iscilikUcreti);
  const yakitTutar = (parseFloat(yolMesafe) / parseFloat(aracTuketimi || 1)) * parseFloat(yakitFiyat);
  const parcaToplamiDoviz = secilenler.reduce((toplam, p) => {
    let fiyat = p.listeFiyat || 0;
    return toplam + (p.adet * fiyat);
  }, 0);
  const parcaToplamiTL = parcaToplamiDoviz * manuelKur;
  const iscilikTL = araToplamIscilik;
  const yakitTL = yakitTutar;
  const toplamMaliyetTL = parcaToplamiTL + iscilikTL + yakitTL;
  const karTutariTL = (toplamMaliyetTL * karYuzdesi) / 100;
  const karDahilToplamTL = toplamMaliyetTL + karTutariTL;
  const araToplamKdvHaric = karDahilToplamTL - ((karDahilToplamTL * iskonto) / 100);
  const kdvTutarTL = kdvDahilMi ? araToplamKdvHaric * kdvOrani : 0;
  const genelToplamTL = araToplamKdvHaric + kdvTutarTL;

  // 👇 YENİ: FİYAT GÖSTERİM FONKSİYONU (TL veya €)
  const formatFiyat = (tlFiyat) => {
    if (teklifParaBirimi === '€') {
      return `${(tlFiyat / manuelKur).toFixed(2)} €`;
    } else {
      return `${tlFiyat.toFixed(2)} ₺`;
    }
  };

  // 👇 YENİ: Türkçe karakterleri koruyan dosya adı temizleme
  const temizleDosyaAdi = (str) => {
    if (!str) return 'Teklif';
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9\sğüşöçıİĞÜŞÖÇ]/g, '')
      .replace(/\s+/g, '_')
      .replace(/_+/g, '_')
      .trim();
  };

  // 👇 YENİ: PDF Oluşturma (teklif için) — ÇOKLU FOTO + EK SAYFA
  const generatePdf = async () => {
    const response = await fetch("/fonts/DejaVuSans.ttf");
    const fontData = await response.arrayBuffer();
    const fontName = "DejaVu";
    const base64Font = btoa(
      new Uint8Array(fontData).reduce((data, byte) => data + String.fromCharCode(byte), "")
    );
    const doc = new jsPDF({ format: "a4", unit: "mm" });
    doc.addFileToVFS(fontName + ".ttf", base64Font);
    doc.addFont(fontName + ".ttf", fontName, "normal");
    doc.setFont(fontName);

    // 🖼️ LOGOLAR
    let logo1EndX = 14;
    try {
      const logo1Res = await fetch('/images/logo.png');
      if (logo1Res.ok) {
        const logo1Blob = await logo1Res.blob();
        const logo1Url = URL.createObjectURL(logo1Blob);
        const logo1Width = 40;
        doc.addImage(logo1Url, 'PNG', 14, 10, logo1Width, 15);
        URL.revokeObjectURL(logo1Url);
        logo1EndX = 14 + logo1Width + 2;
      }
    } catch (err) {
      console.warn("Logo 1 yüklenemedi, devam ediliyor...", err);
    }
    try {
      const logo2Res = await fetch('/images/logo2.png');
      if (logo2Res.ok) {
        const logo2Blob = await logo2Res.blob();
        const logo2Url = URL.createObjectURL(logo2Blob);
        doc.addImage(logo2Url, 'PNG', logo1EndX, 10, 40, 15);
        URL.revokeObjectURL(logo2Url);
      }
    } catch (err) {
      console.warn("Logo 2 yüklenemedi, devam ediliyor...", err);
    }

    // 📄 BAŞLIK VE ŞİRKET BİLGİLERİ
    doc.setFontSize(14);
    doc.text("FİYAT TEKLİFİ", 170, 20, { align: "right" });
    doc.setFontSize(10);
    doc.text(`Tarih: ${new Date().toLocaleDateString('tr-TR')}`, 170, 25, { align: "right" });

    // 👤 MÜŞTERİ BİLGİLERİ
    const mb = musteriBilgileri;
    doc.setFontSize(10);
    doc.text("Firma:", 14, 50);
    doc.setFontSize(8);
    doc.text(`${mb.firma || 'Bilinmiyor'}`, 35, 50);
    doc.setFontSize(10);
    doc.text("Talep No:", 14, 55);
    doc.setFontSize(8);
    doc.text(`${mb.tlpNo || '241190'}`, 35, 55);
    doc.setFontSize(10);
    doc.text("İlgili:", 14, 60);
    doc.setFontSize(8);
    doc.text(`${mb.ilgili || 'Batuhan Şimşek'}`, 35, 60);
    doc.setFontSize(10);
    doc.text("e-mail:", 14, 65);
    doc.setFontSize(8);
    doc.text(`${mb.email || 'info@airmakina.com'}`, 35, 65);
    doc.setFontSize(10);
    doc.text("Gsm:", 14, 70);
    doc.setFontSize(8);
    doc.text(`${mb.gsm || '0546 211 0524'}`, 35, 70);

    // 📊 YETKİLİ BİLGİLERİ
    doc.setFontSize(10);
    doc.text("LUPAMAT BÖLGE BAYİSİ", 100, 50);
    doc.setFontSize(10);
    doc.text("AIR MAKİNA İMALAT SAN. VE TİC. LTD. ŞTİ.", 100, 55);
    doc.setFontSize(10);
    doc.text("Yetkili:", 100, 60);
    doc.setFontSize(8);
    doc.text("Hamza Elbir", 120, 60);
    doc.setFontSize(10);
    doc.text("e-mail:", 100, 65);
    doc.setFontSize(8);
    doc.text("hamza.elbir@airmakina.com", 120, 65);
    doc.setFontSize(10);
    doc.text("Gsm:", 100, 70);
    doc.setFontSize(8);
    doc.text("0 541 332 91 63", 120, 70);
    doc.setFontSize(10);
    doc.text("Teklif No:", 100, 75);
    doc.setFontSize(8);
    doc.text(teklifNo, 120, 75);
    doc.setFontSize(10);
    doc.text(`Para Birimi: ${teklifParaBirimi}`, 100, 80);

    // 📝 KONU VE AÇIKLAMA
    doc.setFontSize(10);
    doc.text("Konu: BAKIM TEKLİFİ", 14, 85);
    doc.setFontSize(8);
    doc.text("Firmamıza göstermiş olduğunuz ilgiden ötürü teşekkür eder, teklifimize olumlu yanıt vermenizi temenni ederiz.", 14, 90);
    doc.text("Her türlü teknik ve ticari sorunuz için yardımcı hazır olduğumuzu hatırlatır, iyi çalışmalar dileriz.", 14, 95);
    doc.text("Saygılarımızla;", 14, 100);

    // 📋 TABLO — SADECE DETAY GÖSTERİLİRSE
    let finalY = 115;
    if (fiyatDetayGoster && secilenler.length > 0) {
      const head = ["Ürün Tipi - Serino", "ACIKLAMA", "ADET"];
      const columnStyles = {
        0: { cellWidth: 30 },
        1: { cellWidth: 50 },
        2: { cellWidth: 20 }
      };
      let colCount = 3;
      if (birimFiyatGoster) {
        head.push("Birim Fiyat");
        head.push("Toplam Fiyat");
        columnStyles[3] = { cellWidth: 30 };
        columnStyles[4] = { cellWidth: 30 };
      }
      const tableRows = secilenler.map((p, index) => {
        const fiyat = p.listeFiyat || 0;
        const tlFiyat = fiyat * manuelKur;
        const karEkliFiyatTL = secilenler.length > 0
          ? tlFiyat + (karTutariTL / secilenler.length)
          : tlFiyat;
        const tlToplam = p.adet * karEkliFiyatTL;
        const row = [
          `${p.kod}`,
          `${p.ad}`,
          String(p.adet)
        ];
        if (birimFiyatGoster) {
          row.push(formatFiyat(karEkliFiyatTL));
          row.push(formatFiyat(tlToplam));
        }
        return row;
      });
      autoTable(doc, {
        head: [head],
        body: tableRows,
        startY: 115,
        theme: 'grid',
        headStyles: { fillColor: [0, 92, 180], textColor: 255 },
        bodyStyles: { font: fontName, fontSize: 9 },
        styles: { halign: "center", valign: "middle" },
        columnStyles
      });
      finalY = doc.lastAutoTable.finalY || 115;
    }

    // 💰 GENEL TOPLAM
    doc.setFontSize(10);
    doc.text(`Ara Toplam (KDV Hariç)`, 100, finalY + 10, { align: "right" });
    doc.text(formatFiyat(araToplamKdvHaric), 140, finalY + 10, { align: "right" });
    if (kdvDahilMi) {
      doc.text(`KDV (%20)`, 100, finalY + 15, { align: "right" });
      doc.text(formatFiyat(kdvTutarTL), 140, finalY + 15, { align: "right" });
    }
    doc.text(`Genel Toplam`, 100, finalY + (kdvDahilMi ? 20 : 15), { align: "right" });
    doc.text(formatFiyat(genelToplamTL), 140, finalY + (kdvDahilMi ? 20 : 15), { align: "right" });

    // 🛠️ BAKIM İŞLERİ
    doc.setFontSize(10);
    doc.text("BAKIM DAHİLİNDE YAPILACAK İŞLER :", 14, finalY + 25 + (kdvDahilMi ? 5 : 0));
    bakimIsleri.forEach((is, idx) => {
      if (is.trim()) {
        doc.setFontSize(8);
        doc.text(is, 14, finalY + 30 + (kdvDahilMi ? 5 : 0) + (idx * 5));
      }
    });

    // 📜 TİCARİ KOŞULLAR
    const ticariStartY = finalY + 45 + (kdvDahilMi ? 5 : 0) + (bakimIsleri.length * 5);
    doc.setFontSize(10);
    doc.text("TİCARİ KOŞULLAR", 14, ticariStartY);
    doc.setFontSize(8);
    doc.text("Teslim süresi", 14, ticariStartY + 5);
    doc.text(`: ${ticariKosullar.teslimSuresi}`, 40, ticariStartY + 5);
    doc.text("Nakliye", 14, ticariStartY + 10);
    doc.text(`: ${ticariKosullar.nakliye}`, 40, ticariStartY + 10);
    doc.text("Ödeme Şekli", 14, ticariStartY + 15);
    doc.text(`: ${ticariKosullar.odemeSekli}`, 40, ticariStartY + 15);
    // 👇 YENİ: Döviz kuru açıklaması (özel metin sadece € için)
    let dovizKuruMetni;
    if (teklifParaBirimi === '€') {
      dovizKuruMetni = 'Fatura tarihindeki VAKIFBANK EURO döviz satış kuru';
    } else {
      dovizKuruMetni = teklifParaBirimi === '₺' ? 'Türk Lirası (₺)' : 'Dolar ($)';
    }
    doc.text("Döviz Kuru", 14, ticariStartY + 20);
    doc.text(`: ${dovizKuruMetni}`, 40, ticariStartY + 20);
    doc.text("K.D.V", 14, ticariStartY + 25);
    doc.text(`: ${ticariKosullar.kdv}`, 40, ticariStartY + 25);

    // 👨‍💼 İMZALAR
    const imzaY = ticariStartY + 40;
    doc.setFontSize(10);
    doc.text("Hamza Elbir", 14, imzaY + 3);
    doc.text("Tel: 0 534 332 9163", 14, imzaY + 9);

    // 🖼️ ALT LOGO
    try {
      const altLogoRes = await fetch('/images/logo-alt.png');
      if (altLogoRes.ok) {
        const altLogoBlob = await altLogoRes.blob();
        const altLogoUrl = URL.createObjectURL(altLogoBlob);
        doc.addImage(altLogoUrl, 'PNG', 14, imzaY + 10, 30, 20);
        URL.revokeObjectURL(altLogoUrl);
      }
    } catch (err) {
      console.warn("Alt logo yüklenemedi, devam ediliyor...", err);
    }

    // 🖼️ ALT İLETİŞİM METNİ
    doc.setFontSize(7);
    doc.text("AIR MAKİNA İMALAT SAN. VE TİC. LTD. ŞTİ.", 14, imzaY + 33);
    doc.text("Yeşiloba mah.46205 sokak EFER 5 SANEYİ SİTESİ D/35", 14, imzaY + 36);
    doc.text("SEYHAN / ADANA", 14, imzaY + 39);
    doc.text("Tel: 0 534 332 9163 | Web: www.airmakina.com.tr", 14, imzaY + 42);

    // 📸 ÇOKLU FOTOĞRAFLAR — GÜNCELLENDİ
    let fotoY = imzaY + 50;
    const fotoGenislik = 85;
    const maxFotolarPerSatir = 2;
    const aralik = 10;
    if (fotoDosyalar.length > 0) {
      for (let i = 0; i < fotoDosyalar.length; i++) {
        const fotoDosya = fotoDosyalar[i];
        try {
          const arrayBuffer = await fotoDosya.arrayBuffer();
          const uint8Array = new Uint8Array(arrayBuffer);
          let binary = '';
          uint8Array.forEach(byte => binary += String.fromCharCode(byte));
          const base64 = btoa(binary);
          let imgFormat = 'JPEG';
          if (fotoDosya.type === 'image/png') imgFormat = 'PNG';
          else if (fotoDosya.type === 'image/webp') imgFormat = 'WEBP';
          const imgProps = doc.getImageProperties(base64);
          const ratio = imgProps.height / imgProps.width;
          const imgHeight = fotoGenislik * ratio;
          if (fotoY + imgHeight > 285) {
            doc.addPage();
            fotoY = 10;
          }
          const kolon = i % maxFotolarPerSatir;
          const x = 15 + kolon * (fotoGenislik + aralik);
          doc.addImage(base64, imgFormat, x, fotoY, fotoGenislik, imgHeight);
          if (kolon === maxFotolarPerSatir - 1 || i === fotoDosyalar.length - 1) {
            fotoY += imgHeight + 10;
          }
        } catch (err) {
          console.warn(`Fotoğraf ${i + 1} işlenemedi:`, err);
        }
      }
    }

    // 📄 EK SAYFA (isteğe bağlı)
    if (ekAciklamalar.trim()) {
      doc.addPage();
      doc.setFontSize(12);
      doc.text("EK AÇIKLAMALAR / ÖZEL KOŞULLAR", 14, 15);
      doc.setFontSize(10);
      const splitText = doc.splitTextToSize(ekAciklamalar, 180);
      doc.text(splitText, 14, 25);
    }

    return doc;
  };

  // 👁️ PDF ÖN İZLEME
  const pdfOnizle = async () => {
    try {
      const doc = await generatePdf();
      const blob = doc.output('blob');
      const url = URL.createObjectURL(blob);
      setPdfOnizlemeUrl(url);
    } catch (err) {
      console.error('PDF ön izleme hatası:', err);
      alert('PDF ön izleme oluşturulamadı: ' + (err.message || 'Bilinmeyen hata'));
    }
  };

  // 💾 SADECE KAYDET
  const pdfKaydet = async () => {
    try {
      const doc = await generatePdf();
      const blob = doc.output('blob');
      const url = URL.createObjectURL(blob);
      const tarih = new Date().toISOString().replace(/[:.]/g, '-').split('T')[0];
      const temizMusteri = temizleDosyaAdi(musteriBilgileri.firma || 'Teklif');
      const dosyaAdi = `Teklif_${temizMusteri}_${tarih}.pdf`;
      const link = document.createElement('a');
      link.href = url;
      link.download = dosyaAdi;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('PDF kaydetme hatası:', err);
      alert('PDF kaydedilemedi: ' + (err.message || 'Bilinmeyen hata'));
    }
  };

  // 👇 YENİ: E-Posta ile Gönderme (mail açıklaması dahil)
  const teklifGonder = async () => {
    const email = prompt("Lütfen teklifin gönderileceği e-posta adresini girin:");
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      alert("Geçerli bir e-posta adresi girilmedi.");
      return;
    }
    try {
      const doc = await generatePdf();
      const blob = doc.output('blob');
      const tarih = new Date().toISOString().replace(/[:.]/g, '-').split('T')[0];
      const temizMusteri = temizleDosyaAdi(musteriBilgileri.firma || 'Teklif');
      const dosyaAdi = `Teklif_${temizMusteri}_${tarih}.pdf`;
      const formDataForEmail = new FormData();
      formDataForEmail.append('pdf', blob, dosyaAdi);
      formDataForEmail.append('email', email);
      formDataForEmail.append('firmaIsmi', musteriBilgileri.firma || 'Teklif');
      // ✅ Mail açıklaması eklendi
      formDataForEmail.append('mailAciklamasi', mailAciklamasi.trim() || 'Sayın yetkili, teklifimizi incelediğiniz için teşekkür ederiz.');
      // ✅ Tip bilgisi eklendi → server bunu "teklif" olarak algılayacak
      formDataForEmail.append('tip', 'teklif');

      const response = await fetch('/api/servis-formu/email-gonder', {
        method: 'POST',
        body: formDataForEmail
      });
      const result = await response.json();
      if (response.ok) {
        alert(`✅ Teklif başarıyla ${email} adresine gönderildi!`);
        // Opsiyonel: gönderdikten sonra alanı temizle
        setMailAciklamasi('');
      } else {
        throw new Error(result.hata || 'E-posta gönderilirken hata oluştu.');
      }
    } catch (err) {
      console.error('E-posta gönderme hatası:', err);
      alert('❌ E-posta gönderilemedi: ' + (err.message || 'Bilinmeyen hata'));
    }
  };

  // 🔹 FOTOĞRAF SİLME
  const handleFotoSil = (index) => {
    setFotoDosyalar(prev => prev.filter((_, i) => i !== index));
  };

  // 🔹 FOTOĞRAF EKLEME
  const handleFotoEkle = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      setFotoDosyalar(prev => [...prev, ...files]);
    }
  };

  // 🔹 BAKIM İŞLERİ İŞLEMLERİ
  const handleBakimEkle = () => {
    if (yeniBakimIsi.trim()) {
      setBakimIsleri([...bakimIsleri, yeniBakimIsi.trim()]);
      setYeniBakimIsi('');
      setSeciliBakimIndex(null);
    }
  };

  const handleBakimSil = () => {
    if (seciliBakimIndex !== null) {
      const yeniListe = bakimIsleri.filter((_, i) => i !== seciliBakimIndex);
      setBakimIsleri(yeniListe);
      setSeciliBakimIndex(null);
    }
  };

  // 🔹 TİCARİ KOŞULLAR GÜNCELLEME
  const handleTicariKosulDegis = (alan, deger) => {
    setTicariKosullar(prev => ({ ...prev, [alan]: deger }));
  };

  // 🔹 SANAL KAYDIRMA SATIRI (tedarikçi modu için)
  const Row = ({ index, style }) => {
    const p = filteredParcalar[index];
    if (!p) return null;
    const fiyatTipi = secilenFiyatlar[p.uniqueKey] || 'liste';
    const isChecked = seciliParcalar.has(p.uniqueKey);
    return (
      <tr style={style} className="hover:bg-gray-25">
        <td className="border-b px-3 py-2">
          <input
            type="checkbox"
            checked={isChecked}
            onChange={() => toggleSecim(p.uniqueKey, p)}
            className="scale-125"
          />
        </td>
        <td className="border-b px-3 py-2 font-mono text-xs">{p.kod}</td>
        <td className="border-b px-3 py-2 text-sm">{p.ad}</td>
        <td className="border-b px-3 py-2 text-right text-sm">{p.listeFiyat?.toFixed(2) ?? '0.00'} €</td>
        <td className="border-b px-3 py-2 text-right text-sm">{p.bayiNakit?.toFixed(2) ?? '0.00'} €</td>
        <td className="border-b px-3 py-2 text-right text-sm">{p.bayi60?.toFixed(2) ?? '0.00'} €</td>
        <td className="border-b px-3 py-2 text-center">
          <div className="flex gap-1 justify-center">
            <button
              onClick={() => handleFiyatSec(p.uniqueKey, 'liste')}
              className={`text-xs px-2 py-1 rounded ${fiyatTipi === 'liste' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
            >
              Liste
            </button>
            <button
              onClick={() => handleFiyatSec(p.uniqueKey, 'bayiNakit')}
              className={`text-xs px-2 py-1 rounded ${fiyatTipi === 'bayiNakit' ? 'bg-green-600 text-white' : 'bg-gray-200'}`}
            >
              Nakit
            </button>
            <button
              onClick={() => handleFiyatSec(p.uniqueKey, 'bayi60')}
              className={`text-xs px-2 py-1 rounded ${fiyatTipi === 'bayi60' ? 'bg-purple-600 text-white' : 'bg-gray-200'}`}
            >
              60 Gün
            </button>
          </div>
        </td>
        <td className="border-b px-3 py-2">
          <input
            type="number"
            value={parcaAdetleri[p.uniqueKey] || 1}
            onChange={(e) => handleParcaDegis(p.uniqueKey, 'adet', e.target.value)}
            className="input w-20 text-center text-sm"
            placeholder="Adet"
          />
        </td>
      </tr>
    );
  };

  // 🔹 DROPDOWN DIŞINA TIKLANINCA KAPAT
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setFirmaDropdownAcik(false);
      }
    };
    if (firmaDropdownAcik) {
      document.addEventListener('click', handleClickOutside);
    }
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [firmaDropdownAcik]);

  // 🔹 FİRMA ARAMA FİLTRELEME (Türkçe karakter ve özel karakter duyarsız)
  const firmalarFiltered = useMemo(() => {
    if (!firmaArama.trim()) return firmalar;
    const normalize = (str) => {
      return str
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9\u00C0-\u017F]/g, '');
    };
    const aramaNorm = normalize(firmaArama);
    return firmalar.filter(firma => normalize(firma).includes(aramaNorm));
  }, [firmaArama, firmalar]);

  // 👇 PDF GÖRÜNÜMÜNE UYGUN ARAYÜZ SIRALAMASI
  return (
    <div className="teklif-formu max-w-4xl mx-auto p-6 bg-white rounded shadow">
      <div id="pdf-content" className="pdf-preview-like">
        {/* LOGO VE BAŞLIK */}
        <div className="pdf-header mb-6">
          <div className="flex items-start">
            <img src="/images/logo.png" alt="Logo" className="h-12 mr-2" />
            <img src="/images/logo2.png" alt="Logo2" className="h-12" />
            <div className="ml-auto text-right">
              <h2 className="text-xl font-bold">FİYAT TEKLİFİ</h2>
              <p>Tarih: {new Date().toLocaleDateString('tr-TR')}</p>
            </div>
          </div>
        </div>

        {/* 👤 MÜŞTERİ SEÇİM BUTONU */}
        <div className="mb-6">
          <button
            onClick={() => setMusteriModalAcik(true)}
            className="bg-blue-600 text-white px-4 py-2 rounded"
          >
            👤 Müşteri Seç veya Yeni Ekle
          </button>
          {seciliMusteriId !== null && (
            <span className="ml-4 text-green-600 font-semibold">
              Seçili: {musteriler.find(m => m.id === seciliMusteriId)?.firma || 'Bilinmiyor'}
            </span>
          )}
        </div>

        {/* MÜŞTERİ BİLGİLERİ (OTOMATİK DOLDURULUR) */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 p-4 bg-gray-50 rounded border">
          <h3 className="col-span-2 text-lg font-semibold">👤 Müşteri Bilgileri</h3>
          <div>
            <label>Firma</label>
            <input
              type="text"
              value={musteriBilgileri.firma}
              readOnly
              className="input bg-gray-100"
            />
          </div>
          <div>
            <label>TALEP NO</label>
            <input
              type="text"
              value={musteriBilgileri.tlpNo}
              onChange={(e) => setMusteriBilgileri(prev => ({ ...prev, tlpNo: e.target.value }))}
              className="input"
              placeholder="Örn: 241190"
            />
          </div>
          <div>
            <label>İlgili Kişi</label>
            <input
              type="text"
              value={musteriBilgileri.ilgili}
              readOnly
              className="input bg-gray-100"
            />
          </div>
          <div>
            <label>E-posta</label>
            <input
              type="email"
              value={musteriBilgileri.email}
              readOnly
              className="input bg-gray-100"
            />
          </div>
          <div className="md:col-span-2">
            <label>GSM</label>
            <input
              type="text"
              value={musteriBilgileri.gsm}
              readOnly
              className="input bg-gray-100"
            />
          </div>
        </div>

        {/* ŞİRKET BİLGİLERİ */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 p-4 bg-blue-50 rounded border">
          <div>
            <p className="font-semibold">LUPAMAT BÖLGE BAYİSİ</p>
            <p>AIR MAKİNA İMALAT SAN. VE TİC. LTD. ŞTİ.</p>
            <p><strong>Yetkili:</strong> Hamza Elbir</p>
            <p><strong>e-mail:</strong> hamza.elbir@airmakina.com</p>
            <p><strong>Gsm:</strong> 0 541 332 91 63</p>
          </div>
          <div>
            <label>🔖 Teklif No</label>
            <input
              type="text"
              value={teklifNo}
              readOnly
              className="input w-full bg-gray-100"
            />
          </div>
        </div>

        {/* PARA BİRİMİ, KAR, FİYAT DETAYI, BİRİM FİYAT */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
          <div className="p-4 bg-green-100 rounded border">
            <label className="block text-lg font-semibold mb-2">💰 Para Birimi</label>
            <div className="flex flex-col gap-2">
              <label className="flex items-center">
                <input
                  type="radio"
                  name="paraBirimi"
                  value="₺"
                  checked={teklifParaBirimi === '₺'}
                  onChange={(e) => setTeklifParaBirimi(e.target.value)}
                  className="mr-2"
                />
                ₺ (Türk Lirası)
              </label>
              <label className="flex items-center">
                <input
                  type="radio"
                  name="paraBirimi"
                  value="€"
                  checked={teklifParaBirimi === '€'}
                  onChange={(e) => setTeklifParaBirimi(e.target.value)}
                  className="mr-2"
                />
                € (Euro)
              </label>
            </div>
          </div>
          <div className="p-4 bg-blue-100 rounded border">
            <label className="block text-lg font-semibold mb-2">📈 Kar Yüzdesi (%)</label>
            <input
              type="number"
              value={karYuzdesi}
              onChange={(e) => setKarYuzdesi(parseFloat(e.target.value) || 0)}
              className="input w-full"
              placeholder="Örn: 20"
            />
          </div>
          <div className="p-4 bg-purple-100 rounded border">
            <label className="block text-lg font-semibold mb-2">📊 Fiyat Detayı</label>
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={fiyatDetayGoster}
                onChange={(e) => setFiyatDetayGoster(e.target.checked)}
                className="mr-2 scale-125"
              />
              Parça fiyatlarını PDF'de göster
            </label>
          </div>
          <div className="p-4 bg-yellow-100 rounded border">
            <label className="block text-lg font-semibold mb-2">🏷️ Birim Fiyat</label>
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={birimFiyatGoster}
                onChange={(e) => setBirimFiyatGoster(e.target.checked)}
                className="mr-2 scale-125"
                disabled={!fiyatDetayGoster}
              />
              Birim ve Toplam fiyatı göster
            </label>
          </div>
        </div>

        {/* KONU VE AÇIKLAMA */}
        <div className="mb-6 p-4 bg-yellow-50 rounded border">
          <h3 className="text-lg font-semibold mb-2">📝 Konu ve Açıklama</h3>
          <p className="text-sm">
            Firmamıza göstermiş olduğunuz ilgiden ötürü teşekkür eder, teklifimize olumlu yanıt vermenizi temenni ederiz.
          </p>
          <p className="text-sm">
            Her türlü teknik ve ticari sorunuz için yardımcı hazır olduğumuzu hatırlatır, iyi çalışmalar dileriz.
          </p>
          <p className="text-sm mt-2">Saygılarımızla,</p>
        </div>

        {/* MOD SEÇİMİ */}
        <div className="flex border-b mb-6">
          <button
            onClick={() => setMod('firma')}
            className={`px-4 py-2 font-semibold ${mod === 'firma' ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-500'}`}
          >
            Firma ile Teklif
          </button>
          <button
            onClick={() => setMod('tedarikci')}
            className={`px-4 py-2 font-semibold ${mod === 'tedarikci' ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-500'}`}
          >
            Tedarikçi ile Teklif
          </button>
        </div>

        {/* MODA GÖRE PARÇA SEÇİM */}
        {mod === 'firma' && (
          <div className="mb-6">
            {/* FIRMA SEÇİMİ - AÇILIR CHECKBOX MENÜ */}
            <div className="mb-4 relative" ref={dropdownRef}>
              <label>Firmalar</label>
              <div
                className="mt-2 border border-gray-300 rounded p-2 bg-white cursor-pointer min-h-[40px] flex items-center justify-between"
                onClick={() => setFirmaDropdownAcik(!firmaDropdownAcik)}
              >
                <div className="flex flex-wrap gap-1">
                  {seciliFirmalar.length === 0 ? (
                    <span className="text-gray-400">Firma seçiniz</span>
                  ) : (
                    seciliFirmalar.map(f => (
                      <span key={f} className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-sm">
                        {f}
                      </span>
                    ))
                  )}
                </div>
                <span>{firmaDropdownAcik ? '▲' : '▼'}</span>
              </div>
              {firmaDropdownAcik && (
                <div
                  className="absolute z-10 mt-1 w-full border border-gray-300 rounded bg-white shadow-lg max-h-60 overflow-auto"
                  onClick={(e) => e.stopPropagation()}
                >
                  {/* 🔍 ARAMA KUTUSU */}
                  <div className="p-2 border-b">
                    <input
                      type="text"
                      placeholder="Firma ara..."
                      className="input w-full text-sm"
                      value={firmaArama}
                      onChange={(e) => setFirmaArama(e.target.value)}
                    />
                  </div>
                  {/* 📋 FİLTRELENMİŞ FİRMA LİSTESİ */}
                  {(firmalarFiltered.length > 0 ? firmalarFiltered : [{ isim: 'Firma bulunamadı', disabled: true }]).map(f => (
                    f.disabled ? (
                      <div key="no-result" className="px-3 py-2 text-gray-500 text-sm italic">
                        {f.isim}
                      </div>
                    ) : (
                      <label key={f} className="flex items-center px-3 py-2 hover:bg-gray-100">
                        <input
                          type="checkbox"
                          checked={seciliFirmalar.includes(f)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSeciliFirmalar(prev => [...prev, f]);
                            } else {
                              setSeciliFirmalar(prev => prev.filter(item => item !== f));
                              const newModeller = { ...seciliModeller };
                              delete newModeller[f];
                              setSeciliModeller(newModeller);
                            }
                          }}
                          className="mr-2"
                        />
                        {f}
                      </label>
                    )
                  ))}
                </div>
              )}
            </div>

            {/* MODEL SEÇİMİ (HER FIRMA İÇİN) */}
            {seciliFirmalar.map(firma => (
              <div key={firma} className="mb-4 p-3 bg-gray-50 rounded">
                <label>Model ({firma})</label>
                <select
                  value={seciliModeller[firma] || ''}
                  onChange={(e) => {
                    const newModeller = { ...seciliModeller };
                    if (e.target.value) {
                      newModeller[firma] = e.target.value;
                    } else {
                      delete newModeller[firma];
                    }
                    setSeciliModeller(newModeller);
                  }}
                  className="input ml-2"
                >
                  <option value="">Model Seçiniz</option>
                  {(modellerByFirma[firma] || []).map(m => (
                    <option key={m} value={m}>{m}</option>
                  ))}
                </select>
              </div>
            ))}

            {/* 🔹 MANUEL PARÇA EKLEME */}
            <div className="mt-6 bg-yellow-50 p-4 rounded border">
              <h3 className="text-lg font-semibold mb-2">🔧 Manuel Parça Ekle</h3>
              <div className="grid grid-cols-1 md:grid-cols-5 gap-2 items-end">
                <div>
                  <label>Parça Kodu</label>
                  <input
                    type="text"
                    value={manuelParcaForm.kod}
                    onChange={(e) => handleManuelParcaDegis('kod', e.target.value)}
                    className="input w-full"
                    placeholder="Kod"
                  />
                </div>
                <div>
                  <label>Parça Adı</label>
                  <input
                    type="text"
                    value={manuelParcaForm.ad}
                    onChange={(e) => handleManuelParcaDegis('ad', e.target.value)}
                    className="input w-full"
                    placeholder="Ad"
                  />
                </div>
                <div>
                  <label>Fiyat</label>
                  <input
                    type="number"
                    step="0.01"
                    value={manuelParcaForm.fiyat}
                    onChange={(e) => handleManuelParcaDegis('fiyat', e.target.value)}
                    className="input w-full"
                    placeholder="Fiyat"
                  />
                </div>
                <div>
                  <label>Adet</label>
                  <input
                    type="number"
                    value={manuelParcaForm.adet}
                    onChange={(e) => handleManuelParcaDegis('adet', e.target.value)}
                    className="input w-full"
                    placeholder="Adet"
                  />
                </div>
                <div>
                  <label>Döviz</label>
                  <select
                    value={manuelParcaForm.doviz}
                    onChange={(e) => handleManuelParcaDegis('doviz', e.target.value)}
                    className="input w-full"
                  >
                    <option value="€">€</option>
                    <option value="$">$</option>
                  </select>
                </div>
              </div>
              <button
                onClick={handleManuelParcaEkle}
                className="mt-2 bg-green-600 text-white px-4 py-2 rounded text-sm"
              >
                ➕ Parça Ekle
              </button>
            </div>

            {/* PARÇA LİSTESİ (HER FIRMA/MODEL İÇİN) */}
            <div className="mt-6">
              {Object.entries(parcalarMap).map(([key, parcalarList]) => {
                const [firma, model] = key.split('|');
                return (
                  <div key={key} className="mb-6">
                    <h4 className="font-bold text-lg mb-2">{firma} - {model}</h4>
                    <div className="grid gap-3">
                      {parcalarList.map((p, i) => (
                        <div
                          key={p.uniqueKey}
                          className={`teklif-parca-karti ${seciliParcalar.has(p.uniqueKey) ? 'secilmis' : ''}`}
                          onClick={() => toggleSecim(p.uniqueKey, p)}
                        >
                          <div className="parca-adi">{p.ad}</div>
                          <div className="detay">({p.kod}) – {p.tedarikci} – <strong>{(p.fiyat || 0).toFixed(2)} €</strong></div>
                          {seciliParcalar.has(p.uniqueKey) && (
                            <>
                              <select
                                className="input mt-2"
                                value={p.seciliIndex}
                                onClick={(e) => e.stopPropagation()}
                                onChange={(e) => handleTedarikciSec(p.uniqueKey, parseInt(e.target.value), p.tedarikciler)}
                              >
                                {p.tedarikciler.map((t, idx) => {
                                  const fiyat = parseFloat(t.fiyat) || 0;
                                  return (
                                    <option key={idx} value={idx}>
                                      {t.adi} – {t.kod} – {fiyat.toFixed(2)} €
                                    </option>
                                  );
                                })}
                              </select>
                              <div className="flex gap-2 mt-2" onClick={(e) => e.stopPropagation()}>
                                <input
                                  type="number"
                                  placeholder="Adet"
                                  value={parcaAdetleri[p.uniqueKey] || 1}
                                  onChange={(e) => handleParcaDegis(p.uniqueKey, 'adet', e.target.value)}
                                  className="input w-24"
                                />
                                <input
                                  type="number"
                                  placeholder="Fiyat"
                                  value={p.fiyat}
                                  readOnly
                                  className="input w-24 bg-gray-100"
                                />
                              </div>
                            </>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {mod === 'tedarikci' && (
          <div className="tedarikci-modu mb-6">
            <div className="mb-4">
              <label>Tedarikçi Seçin</label>
              <select
                value={seciliTedarikci}
                onChange={(e) => setSeciliTedarikci(e.target.value)}
                className="input w-full"
              >
                <option value="">Tedarikçi Seçiniz</option>
                {tedarikciler.map(t => (
                  <option key={t.id} value={t.id}>{t.ad}</option>
                ))}
              </select>
            </div>
            {seciliTedarikci && (
              <div className="mb-4">
                <input
                  type="text"
                  placeholder="🔍 Parça adı veya kod ile ara..."
                  value={aramaKelimesi}
                  onChange={(e) => setAramaKelimesi(e.target.value)}
                  className="w-full border border-gray-300 p-2 rounded"
                />
              </div>
            )}
            {aramaKelimesi && filteredParcalar.length > 0 && (
              <div className="overflow-hidden border border-gray-200 rounded-lg shadow-sm" style={{ height: '400px' }}>
                <List
                  height={400}
                  itemCount={filteredParcalar.length}
                  itemSize={48}
                  itemData={filteredParcalar}
                  width="100%"
                >
                  {Row}
                </List>
              </div>
            )}
            {aramaKelimesi && filteredParcalar.length === 0 && (
              <p className="text-center py-4 text-gray-500">
                "{aramaKelimesi}" için parça bulunamadı.
              </p>
            )}
          </div>
        )}

        {/* SEÇİLEN PARÇALAR */}
        {(tumSecilenParcalar.length > 0) && (
          <div className="mt-6 bg-gray-50 p-4 rounded border">
            <h3 className="text-lg font-semibold mb-3">✅ Seçilen Parçalar ({tumSecilenParcalar.length})</h3>
            <div className="overflow-auto max-h-60 border rounded">
              <table className="min-w-full bg-white">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border px-2 py-1 text-xs">Kod</th>
                    <th className="border px-2 py-1 text-xs">Ad</th>
                    <th className="border px-2 py-1 text-xs">Tedarikçi</th>
                    <th className="border px-2 py-1 text-xs">Adet</th>
                    <th className="border px-2 py-1 text-xs">Fiyat Tipi</th>
                    {birimFiyatGoster && <th className="border px-2 py-1 text-xs">Birim Fiyat</th>}
                    {birimFiyatGoster && <th className="border px-2 py-1 text-xs">Toplam ({teklifParaBirimi})</th>}
                    <th className="border px-2 py-1 text-xs">İşlem</th>
                  </tr>
                </thead>
                <tbody>
                  {tumSecilenParcalar.map((p, i) => {
                    const tip = p.fiyatTipi || 'liste';
                    const fiyat = tip === 'bayiNakit' ? (p.bayiNakit || 0) : tip === 'bayi60' ? (p.bayi60 || 0) : (p.listeFiyat || 0);
                    const tlFiyat = fiyat * manuelKur;
                    const tlToplam = p.adet * tlFiyat;
                    const toplamGosterim = formatFiyat(tlToplam);
                    const birimGosterim = formatFiyat(tlFiyat);
                    return (
                      <tr key={p.manuelId || p.uniqueKey || i} className="hover:bg-gray-50 text-xs">
                        <td className="border px-2 py-1 font-mono">{p.kod}</td>
                        <td className="border px-2 py-1">{p.ad}</td>
                        <td className="border px-2 py-1">{p.tedarikci}</td>
                        <td className="border px-2 py-1 text-center">{p.adet}</td>
                        <td className="border px-2 py-1 text-center">{tip}</td>
                        {birimFiyatGoster && <td className="border px-2 py-1 text-right">{birimGosterim}</td>}
                        {birimFiyatGoster && <td className="border px-2 py-1 text-right">{toplamGosterim}</td>}
                        <td className="border px-2 py-1 text-center">
                          <button
                            onClick={() => {
                              if (p.manuelId) {
                                handleManuelParcaSil(p.manuelId);
                              } else {
                                handleRemove(p.uniqueKey);
                              }
                            }}
                            className="bg-red-500 text-white text-xs px-2 py-1 rounded hover:bg-red-600"
                          >
                            Sil
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* EK MALİYETLER */}
        <div className="mt-6">
          <button
            onClick={() => setEkMaliyetlerAcik(!ekMaliyetlerAcik)}
            className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded w-full text-left flex justify-between items-center"
          >
            <span>🛠️ EK MALİYETLER</span>
            <span>{ekMaliyetlerAcik ? '▲' : '▼'}</span>
          </button>
          {ekMaliyetlerAcik && (
            <div className="mt-4 p-4 border rounded bg-gray-50">
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label>Döviz</label>
                  <select value={doviz} onChange={(e) => setDoviz(e.target.value)} className="input">
                    <option value="₺">₺</option>
                    <option value="€">€</option>
                    <option value="$">$</option>
                  </select>
                </div>
                <div>
                  <label>İşçilik Saati</label>
                  <input type="number" value={iscilikSaat} onChange={(e) => setIsclikSaat(e.target.value)} className="input" placeholder="Örn: 4" />
                </div>
                <div>
                  <label>İşçilik Ücreti (₺)</label>
                  <input type="number" value={iscilikUcreti} onChange={(e) => setIsclikUcreti(e.target.value)} className="input" placeholder="Örn: 300" />
                </div>
                <div>
                  <label>Yol Mesafesi (km)</label>
                  <input type="number" value={yolMesafe} onChange={(e) => setYolMesafe(e.target.value)} className="input" placeholder="Örn: 85" />
                </div>
                <div>
                  <label>Araç Tüketimi (km/L)</label>
                  <input type="number" value={aracTuketimi} onChange={(e) => setAracTuketimi(e.target.value)} className="input" placeholder="Örn: 10" />
                </div>
                <div>
                  <label>Yakıt Fiyatı (₺/L)</label>
                  <input type="number" value={yakitFiyat} onChange={(e) => setYakitFiyat(e.target.value)} className="input" placeholder="Örn: 35" />
                </div>
              </div>
            </div>
          )}
        </div>

        {/* DÖVİZ KURU */}
        <div className="mt-6 bg-blue-50 p-4 rounded border">
          <h3 className="text-lg font-semibold mb-3">💱 Döviz Kuru (Manuel)</h3>
          <div className="grid md:grid-cols-2 gap-4 items-end">
            <div>
              <label>Döviz Türü</label>
              <select
                value={seciliDoviz}
                onChange={(e) => setSeciliDoviz(e.target.value)}
                className="input w-full"
              >
                <option value="EUR">Euro (€)</option>
                <option value="USD">Dolar ($)</option>
              </select>
            </div>
            <div>
              <label>{seciliDoviz === 'EUR' ? '1 €' : '1 $'} = ___ ₺</label>
              <input
                type="number"
                step="0.01"
                value={manuelKur}
                onChange={(e) => setManuelKur(parseFloat(e.target.value) || 0)}
                className="input w-full"
              />
            </div>
          </div>
        </div>

        {/* BAKIM İŞLERİ */}
        <div className="mt-6 bg-green-50 p-4 rounded border">
          <h3 className="text-lg font-semibold mb-2">🛠️ Bakım Dahilinde Yapılacak İşler</h3>
          <div className="flex gap-2 mb-2">
            <input
              type="text"
              value={yeniBakimIsi}
              onChange={(e) => setYeniBakimIsi(e.target.value)}
              className="input flex-50"
              placeholder="Yeni iş ekle..."
            />
            <button onClick={handleBakimEkle} className="bg-blue-600 text-white px-2 py-1 rounded text-sm">
              Ekle
            </button>
            <button
              onClick={handleBakimSil}
              disabled={seciliBakimIndex === null}
              className={`px-2 py-1 rounded text-sm ${
                seciliBakimIndex !== null ? 'bg-red-600 text-white' : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
            >
              Sil
            </button>
          </div>
          <ul className="list-disc pl-5 space-y-1">
            {bakimIsleri.map((is, idx) => (
              <li
                key={idx}
                className={`cursor-pointer ${seciliBakimIndex === idx ? 'font-bold text-blue-600' : ''}`}
                onClick={() => setSeciliBakimIndex(idx)}
              >
                {is}
              </li>
            ))}
          </ul>
        </div>

        {/* TİCARİ KOŞULLAR */}
        <div className="mt-6 bg-purple-50 p-4 rounded border">
          <h3 className="text-lg font-semibold mb-3">📜 Ticari Koşullar</h3>
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label>Teslim Süresi</label>
              <input
                type="text"
                value={ticariKosullar.teslimSuresi}
                onChange={(e) => handleTicariKosulDegis('teslimSuresi', e.target.value)}
                className="input w-full"
              />
            </div>
            <div>
              <label>Nakliye</label>
              <input
                type="text"
                value={ticariKosullar.nakliye}
                onChange={(e) => handleTicariKosulDegis('nakliye', e.target.value)}
                className="input w-full"
              />
            </div>
            <div>
              <label>Ödeme Şekli</label>
              <input
                type="text"
                value={ticariKosullar.odemeSekli}
                onChange={(e) => handleTicariKosulDegis('odemeSekli', e.target.value)}
                className="input w-full"
              />
            </div>
            <div>
              <label>Döviz Kuru</label>
              <input
                type="text"
                value={teklifParaBirimi === '€' ? 'Euro (€)' : 'Türk Lirası (₺)'}
                readOnly
                className="input w-full bg-gray-100"
              />
            </div>
            <div className="md:col-span-2">
              <label>K.D.V</label>
              <input
                type="text"
                value={ticariKosullar.kdv}
                onChange={(e) => handleTicariKosulDegis('kdv', e.target.value)}
                className="input w-full"
              />
            </div>
          </div>
        </div>

        {/* KDV SEÇİMİ */}
        <div className="mt-4">
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={kdvDahilMi}
              onChange={(e) => setKdvDahilMi(e.target.checked)}
              className="scale-125"
            />
            Fiyata KDV dahil olsun mu?
          </label>
        </div>

        {/* FOTOĞRAF YÜKLEME */}
        <div className="mt-6 p-4 bg-green-50 rounded border">
          <label className="block text-lg font-semibold mb-2">📸 Fotoğraf(lar) Ekle (İsteğe Bağlı)</label>
          <input
            type="file"
            accept="image/*"
            multiple
            onChange={handleFotoEkle}
            className="input w-full"
          />
          {fotoUrlList.length > 0 && (
            <div className="mt-3 grid grid-cols-2 sm:grid-cols-3 gap-2">
              {fotoUrlList.map((url, index) => (
                <div key={index} className="relative inline-block">
                  <img src={url} alt={`Önizleme ${index + 1}`} className="max-h-32 rounded border" />
                  <button
                    onClick={() => handleFotoSil(index)}
                    className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs"
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* EK AÇIKLAMALAR */}
        <div className="mt-6 p-4 bg-yellow-50 rounded border">
          <label className="block text-lg font-semibold mb-2">📄 Ek Sayfa – Özel Açıklamalar / Koşullar (İsteğe Bağlı)</label>
          <textarea
            value={ekAciklamalar}
            onChange={(e) => setEkAciklamalar(e.target.value)}
            className="input w-full h-32"
            placeholder="Buraya özel koşullar, notlar, ek maddeler yazabilirsiniz..."
          />
        </div>

        {/* 📧 MAİL AÇIKLAMASI */}
        <div className="mt-6 p-4 bg-blue-50 rounded border">
          <label className="block text-lg font-semibold mb-2">📧 Mail Açıklaması (İsteğe Bağlı)</label>
          <textarea
            value={mailAciklamasi}
            onChange={(e) => setMailAciklamasi(e.target.value)}
            className="input w-full h-24"
            placeholder="Teklifi gönderirken e-posta ile birlikte gönderilecek açıklama metnini buraya yazabilirsiniz..."
          />
        </div>

        {/* SONUÇLAR */}
        <div className="sonuclar mt-6 p-4 bg-gray-100 rounded">
          <p>Parça Toplamı (maliyet): {formatFiyat(parcaToplamiTL)}</p>
          <p>İşçilik: {formatFiyat(iscilikTL)}</p>
          <p>Yakıt Tutarı: {formatFiyat(yakitTL)}</p>
          <p>Toplam Maliyet: {formatFiyat(toplamMaliyetTL)}</p>
          <p>Kar (%{karYuzdesi}): {formatFiyat(karTutariTL)}</p>
          <p>Kar Dahil Toplam: {formatFiyat(karDahilToplamTL)}</p>
          <p>İskonto: {formatFiyat((karDahilToplamTL * iskonto) / 100)}</p>
          {kdvDahilMi && <p>KDV (%20): {formatFiyat(kdvTutarTL)}</p>}
          <h3 className="text-xl font-semibold mt-2">Genel Toplam: {formatFiyat(genelToplamTL)}</h3>
        </div>

        {/* İMZALAR */}
        <div className="mt-6 p-4 bg-gray-50 rounded border">
          <p className="font-semibold">Hamza Elbir</p>
          <p>Tel: 0 534 332 9163</p>
        </div>

        {/* ALT BİLGİLER */}
        <div className="mt-4 text-xs text-gray-600">
          <p>AIR MAKİNA İMALAT SAN. VE TİC. LTD. ŞTİ.</p>
          <p>Yeşiloba mah.46205 sokak EFER 5 SANEYİ SİTESİ D/35</p>
          <p>SEYHAN / ADANA</p>
          <p>Tel: 0 534 332 9163 | Web: www.airmakina.com.tr</p>
        </div>
      </div>

      {/* BUTONLAR */}
      <div className="mt-6 flex gap-4">
        <button onClick={pdfOnizle} className="bg-indigo-600 text-white px-4 py-2 rounded">👁️ Ön İzle</button>
        <button onClick={pdfKaydet} className="bg-blue-600 text-white px-4 py-2 rounded">💾 PDF Kaydet</button>
        <button onClick={teklifGonder} className="bg-green-600 text-white px-4 py-2 rounded">📧 Mail Gönder</button>
      </div>

      {/* PDF ÖN İZLEME */}
      {pdfOnizlemeUrl && (
        <div className="mt-8">
          <h3 className="text-lg font-semibold mb-2">📄 PDF Ön İzleme</h3>
          <iframe
            src={pdfOnizlemeUrl}
            title="Teklif Ön İzleme"
            width="100%"
            height="600px"
            style={{ border: '1px solid #ccc', borderRadius: '4px' }}
          />
          <button
            onClick={() => {
              URL.revokeObjectURL(pdfOnizlemeUrl);
              setPdfOnizlemeUrl(null);
            }}
            className="mt-2 text-red-600 hover:text-red-800"
          >
            Ön izlemeyi kapat
          </button>
        </div>
      )}

      {/* 👤 MÜŞTERİ MODAL */}
      {musteriModalAcik && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold">👤 Müşteri Seç veya Yeni Ekle</h2>
                <button
                  onClick={() => setMusteriModalAcik(false)}
                  className="text-gray-500 hover:text-gray-700 text-2xl"
                >
                  &times;
                </button>
              </div>

              {/* MEVCUT MÜŞTERİLER */}
              <div className="mb-6">
                <h3 className="font-semibold mb-2">Kayıtlı Müşteriler</h3>
                {musteriler.length === 0 ? (
                  <p className="text-gray-500">Henüz müşteri kaydı yok.</p>
                ) : (
                  <div className="space-y-2 max-h-60 overflow-y-auto border rounded p-2">
                    {musteriler.map(m => (
                      <div key={m.id} className="flex justify-between items-center p-2 hover:bg-gray-100">
                        <div>
                          <strong>{m.firma}</strong> - {m.ilgili || '—'} ({m.email || '—'})
                        </div>
                        <div>
                          <button
                            onClick={() => handleMusteriSec(m.id)}
                            className="bg-blue-600 text-white text-xs px-2 py-1 rounded mr-2"
                          >
                            Seç
                          </button>
                          <button
                            onClick={() => handleMusteriSil(m.id)}
                            className="bg-red-600 text-white text-xs px-2 py-1 rounded"
                          >
                            Sil
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* YENİ MÜŞTERİ FORMU */}
              <div className="border-t pt-4">
                <h3 className="font-semibold mb-2">➕ Yeni Müşteri Ekle</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div>
                    <label>Firma *</label>
                    <input
                      type="text"
                      value={yeniMusteriForm.firma}
                      onChange={(e) => handleYeniMusteriDegis('firma', e.target.value)}
                      className="input w-full"
                      placeholder="Firma Adı"
                    />
                  </div>
                  <div>
                    <label>İlgili Kişi</label>
                    <input
                      type="text"
                      value={yeniMusteriForm.ilgili}
                      onChange={(e) => handleYeniMusteriDegis('ilgili', e.target.value)}
                      className="input w-full"
                      placeholder="İsim Soyisim"
                    />
                  </div>
                  <div>
                    <label>E-posta</label>
                    <input
                      type="email"
                      value={yeniMusteriForm.email}
                      onChange={(e) => handleYeniMusteriDegis('email', e.target.value)}
                      className="input w-full"
                      placeholder="ornek@mail.com"
                    />
                  </div>
                  <div>
                    <label>GSM</label>
                    <input
                      type="text"
                      value={yeniMusteriForm.gsm}
                      onChange={(e) => handleYeniMusteriDegis('gsm', e.target.value)}
                      className="input w-full"
                      placeholder="05xx xxx xx xx"
                    />
                  </div>
                </div>
                <button
                  onClick={handleYeniMusteriEkle}
                  className="mt-3 bg-green-600 text-white px-4 py-2 rounded"
                >
                  ➕ Yeni Müşteri Kaydet
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeklifGonder;